import { trackCTAInteraction } from "../../utilities/trackCTAInteraction";
import { Button } from "@asosteam/asos-web-component-library-button";
import PropTypes from "prop-types";

const DownloadApp = ({ isPreSale }) => {
  return (
    <Button
      disabled={false}
      isInProgress={false}
      buttonType="primary-asos-world"
      size="default"
      elementOverride="a"
      href="/discover/our-apps?campaign=membersDay-landingPage"
      onClick={() => {
        trackCTAInteraction("members-day-button-click", {
          pageName: `members day ${
            isPreSale ? "plan your buy" : "live event"
          } landing page`,
          buttonType: "members day desktop web get the app",
        });
      }}
    >
      Download Now
    </Button>
  );
};

DownloadApp.propTypes = {
  isPreSale: PropTypes.bool,
};

DownloadApp.defaultProps = {
  isPreSale: false,
};

export default DownloadApp;
